import React from 'react'
import './NotRegisterPopUp.css'
import { GiCancel } from "react-icons/gi";
import { Link } from 'react-router-dom';

export default function NotRegisterPopUp({setPopup}) {
    return (
        <div className='container_NotRegister'>
    
            <div className='subContain_NotRegister'>

                <p className='not_register_msg'>
                    <span className='color_icon'> <GiCancel />  </span>You are not register your self Please Register..

                </p>
               <Link to='/Register'> <button className='ok_register'>OK</button></Link>
            </div>
            <img
                src="/images/cross-circle3.svg"
                className="Cross_notRegister"
                onClick={(e) => setPopup(false)}
                alt='cross logo'
            />
        </div>
    )
}
